import React from 'react';
import {NumberInputContext} from './NumberInputContext';

export const useNumberInputContext = () => React.useContext(NumberInputContext);
